export const title = 'Values'
export const comment = 'I was once asked to think of five values that define me. The ones that I hope apply most to me are listed below, in no particular order.'

export const values = [
  // {
  //   title: "Dignity",
  //   introduction: "The state or quality of being worthy of honour or respect, knowing and doing what is morally right.",
  //   contents: [
  //     "****** coming soon ******",
  //   ],
  //   display: false
  // },
  {
    title: "Adaptability",
    introduction: "Willing and able to quickly adapt to situations.",
    contents: [
      "****** coming soon ******",
    ],
    display: false
  },
  {
    title: "Trust",
    introduction: "Firm belief in the reliability, truth, or ability of someone or something.",
    contents: [
      "****** coming soon ******",
    ],
    display: false
  },
  {
    title: "Fairness",
    introduction: "Impartial and just treatment or behaviour without favouritism or discrimination.",
    contents: [
      "****** coming soon ******",
    ],
    display: false
  },
  {
    title: "Dependability",
    introduction: "The quality of being trustworthy and reliable.",
    contents: [
      "****** coming soon ******",
    ],
    display: false
  },
  // {
  //   title: "Decisiveness",
  //   introduction: "The ability to make decisions quickly and effectively.",
  //   contents: [
  //     "****** coming soon ******",
  //   ],
  //   display: false
  // },
  {
    title: "Honesty",
    introduction: "The quality of being honest.",
    contents: [
      "****** coming soon ******",
    ],
    display: false
  },
  
];

  // 'Experienced Engineer',
  // 'Function over form',
  // 'Minimalist, no frills',
  // 'Perfectionist',
  // 'Collaborator',
  // 'Innovative',
  // 'Intuitive',
  // 'Persistence',
  // 'Loyalty',
  // 'Dedication',
  // 'Family',
  // 'Accountability',
  // 'Sincerity',
  // 'Tolerance',
  // 'Valour',
  // 'Competence',
  // 'Consistency',
  // 'Common sense',